import t from "./ghl-ui.es1309.js";
import o from "./ghl-ui.es1310.js";
function p(r) {
  return o(t(r).toLowerCase());
}
export {
  p as default
};
